const EMI_MARKER_PATTERN = /EMI(?: starting)? @ ₹/i;

export const cleanProductTitle = (productName: string): string => {
  const emiIndex = productName.search(EMI_MARKER_PATTERN);
  if (emiIndex === -1) {
    return productName.trim();
  }

  let start = emiIndex;
  while (start > 0 && /\s/.test(productName[start - 1]!)) {
    start -= 1;
  }
  if (start > 0 && "-–—".includes(productName[start - 1]!)) {
    start -= 1;
    while (start > 0 && /\s/.test(productName[start - 1]!)) {
      start -= 1;
    }
  }

  return productName.slice(0, start).trim();
};

/** Numbers after ₹ only. `/` (or any other non-digit) is ignored as a delimiter — digits are taken either way. */
export const extractEmiPrice = (productName: string): string => {
  const rupeeIndex = productName.indexOf("₹");
  if (rupeeIndex === -1) {
    return "0";
  }

  let i = rupeeIndex + 1;
  while (i < productName.length && productName[i] === " ") {
    i += 1;
  }

  let digits = "";
  for (; i < productName.length; i++) {
    const char = productName[i]!;
    if (char >= "0" && char <= "9") {
      digits += char;
      continue;
    }
    if (char === ",") {
      continue;
    }
    break;
  }

  return digits || "0";
};

export const hasPositiveAmount = (amount: string | number | null | undefined): boolean => {
  if (typeof amount === "number") {
    return Number.isFinite(amount) && amount > 0;
  }

  const normalized = (amount ?? "").replace(/,/g, "").trim();
  if (!/^\d+(?:\.\d+)?$/.test(normalized)) {
    return false;
  }

  const parsedAmount = Number(normalized);
  return Number.isFinite(parsedAmount) && parsedAmount > 0;
};

export const formatAmount = (amount: string): string => {
  const n = Number.parseInt((amount ?? "").replace(/,/g, ""), 10);
  if (Number.isNaN(n)) {
    return amount || "0";
  }
  return n.toLocaleString("en-IN");
};
